"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _TagSet_1 = require("./_TagSet");
exports.GetBucketTaggingOutput = {
    type: "structure",
    required: ["TagSet"],
    members: {
        TagSet: {
            shape: _TagSet_1._TagSet
        }
    }
};
//# sourceMappingURL=GetBucketTaggingOutput.js.map